module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-if=\"vm.closeButton\" ng-if=\"!vm.hideCloseCross\" ng-click=\"vm.cancel()\">×</button>\n    <h4 class=\"modal-title\" ng-bind=\"vm.title\"></h4>\n</div>\n<div class=\"modal-body\" ng-bind-html=\"vm.body\">\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" ng-click=\"vm.ok()\" class=\"{{vm.okClass}}\">{{ vm.okTxt }}</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/common/components/alertPopup/alertPopup.html
// module id = 622
// module chunks = 6